export const localStorageKeys = {
  TOKEN: 'token',
  LAST_ORDER: 'lastOrder',
};
